// src/components/HomeComponents/DemoSection.jsx
import React, { useState, useEffect } from 'react';
import '../../styles/EduComponents/DemoSection.css';
import demoImage from '../../assets/Images/Group 228.webp'; // Make sure to have this image in assets

const DemoSection = () => {
  
   const handleClick = () => {
    const tidycalUrl = process.env.REACT_APP_TIDYCAL_URL;

    try {
      // OPEN IN SAME TAB → required for redirect to work
      window.location.href = tidycalUrl;
    } catch (error) {
      console.error('Error opening TidyCal booking page:', error);
      alert('An error occurred while trying to open the booking page. Please try again later.');
    }
  };


  return (
    <section className="demo-section">
      <div className="demo-content">
        <h2>
          Start Teaching More and Managing Less
        </h2>
        <p>
          Book your personalized demo today and see how Strawket can transform your academy within days, not months.
        </p>
        <button onClick={handleClick} className="demo-btn6">Book A Demo</button>
      </div>
      <div className="demo-image-container">
        <img src={demoImage} alt="Book a demo illustration" className='demo-image'/>
      </div>
    </section>
  );
};

export default DemoSection;
